import { 
    memo, 
    useRef, 
    useState 
} from "react";
import { Form, Card } from "react-bootstrap";

import ComboCliente from "../../../../Componentes/ComboCliente";
import axios from "axios";
import MaskedInput from "react-maskedinput";
import InputCnpj from "../../../../../../componentes/InputCnpj";

function Subestipulante({
    dados,
    alterarDados,
    idClienteAtual=null
}) {
    const cpfInputRef = useRef(null);
    const [carregando, alterarCarregando] = useState(false);

    // consulta id do cliente
    async function consultarId(id) {

        // caso desselecionou o cliente
        if(!id) {
            
            // zera dados
            alterarDados({
                ...dados,
                id_cliente: null,
                tipo_pessoa: "F",
                nome: null,
                cpf: null,
                cnpj: null,
            });
            return;
        }

        // ativa o carregamento
        alterarCarregando(true);

        try {

            // faz a requisição
            const { data } = await axios.get(`/clientes/${id}`);
            
            // se não for o mesmo cliente
            if(parseInt(data.dados.id) !== parseInt(idClienteAtual || 0)) {

                // altera dados subestipulante
                alterarDados({
                    ...dados,
                    id_cliente: data.dados.id,
                    tipo_pessoa: data.dados.tipo_pessoa,
                    nome: data.dados.nome,
                    cpf: data.dados.tipo_pessoa === "F" ? data.dados.cpf : null,
                    cnpj: data.dados.tipo_pessoa === "J" ? data.dados.cnpj : null,
                });

            }
        } catch (e) {
            console.log(e);
        } finally {
            // finaliza carregamento
            alterarCarregando(false);
        }

    }
    
    return (
        <Card.Body>
            <Form.Group>
                <Form.Label>Subestipulante</Form.Label>
                <ComboCliente 
                    id={dados?.id_cliente ?? null}
                    alterou={consultarId}
                    placeholder='Subestipulante'                    
                />
            </Form.Group>
            <Form.Group className='mt-3'>
                <Form.Label>Tipo de pessoa</Form.Label>
                <Form.Group className="flex-column d-flex">
                    <Form.Check
                        label="Pessoa Física"
                        type={'radio'}
                        value="F"
                        name='tipo_pessoa_subestipulante_F'
                        checked={(dados?.tipo_pessoa === 'F') ? true : false}
                        id={`checkbox-tipo-cliente-subestipulante-f`}
                        onChange={e => {
                            if(!e?.target?.value) return;
                            dados.tipo_pessoa = e.target.value;
                            alterarDados({ ...dados });
                        }}
                    />
                    <Form.Check
                        label="Pessoa Jurídica"
                        type={'radio'}
                        value="J"
                        name='tipo_pessoa_subestipulante_J'
                        checked={(dados?.tipo_pessoa === 'J') ? true : false}
                        id={`checkbox-tipo-cliente-subestipulante-j`}
                        onChange={e => {
                            if(!e?.target?.value) return;
                            dados.tipo_pessoa = e.target.value;
                            alterarDados({ ...dados });
                        }}
                        className="mt-1"
                    />
                </Form.Group>
            </Form.Group>
            <Form.Group className='mt-3'>
                <Form.Label>Nome ou Razão Social</Form.Label>
                <Form.Control
                    value={dados?.nome || ''}
                    onChange={e => {
                        dados.nome = e.target.value;
                        alterarDados({ ...dados });            
                    }}
                    disabled={carregando}
                />
            </Form.Group>            
            <Form.Group className='mt-3'>
                <Form.Label>CPF ou CNPJ</Form.Label>
                {dados?.tipo_pessoa === "F" ? 
                    <MaskedInput
                        className={"form-control"}
                        mask="111.111.111-11"
                        value={dados?.cpf || ''}
                        ref={cpfInputRef}
                        onChange={e => {
                            dados.cpf = cpfInputRef.current.mask.getRawValue().split('_').join('');
                            alterarDados({ ...dados });
                        }}
                        disabled={carregando}
                    /> :
                    <InputCnpj 
                        cpnj={dados?.cnpj ?? ''}
                        retornarCnpj={cnpj => {
                            dados.cnpj = cnpj;
                            alterarDados({ ...dados });
                        }}
                        disabled={carregando}
                    />
                }
            </Form.Group>
        </Card.Body>
    );

}

export default memo(Subestipulante)